<template>
  <div class="user-card">
    <div class="base">
      <Avatar :src="head_img" icon="ios-person" style="flex-shrink: 0;" size="48" />
      <span class="user-name text-cut-2">{{nickname}}</span>
    </div>
    <div class="edit-user" @click="$router.push({name:'user_center'})">
      <Icon type="md-create" color="#777" />
      编辑资料
    </div>
  </div>
</template>

<script>
  export default {
    name: 'userCard',
    data() {
      return {
        balance: 0,
        head_img: '',
        nickname: '',
      }
    },
    created() {
      let vm = this
      //
      this.$request('617fe15a973d2').then(res => {
        vm.balance = res.data.data.balance
        vm.head_img = res.data.data.head_img
        vm.nickname = res.data.data.nickname
        vm.check = res.data.data.check
      })

     
    },
  }
</script>

<style scoped lang="less">
  .user-card {
    width: 357px;
    padding: 30px 26px 34px;
    border-radius: 12px;
    background-image: linear-gradient(180deg, #f5f8ff, #fff);

    //box-shadow: inset 0 1px 3px 0 hsl(0deg 0% 100% / 50%);
    .base {
      display: flex;
      align-items: center;

      .user-name {
        color: #111;
        font-weight: 500;
        font-size: 18px;
        margin-left: 10px;
		word-wrap: break-word;
      }
    }

    .edit-user {
      display: flex;
      align-items: center;
      width: 100px;
      height: 28px;
      padding: 0 9px;
      cursor: pointer;
      border: 1px solid #c4c6cf;
      margin-left: 55px;
      border-radius: 20px;
      color: #111111;
      font-size: 12px;
      margin-top: 10px;

      i {
        margin-right: 5px;
      }
    }
  }
</style>
